import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BrandModel } from 'projects/Administration/src/app/business-entities/brand-view-model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { BrandService } from 'projects/Administration/src/app/business-services/brand.service';
import { ImageService } from 'projects/Administration/src/app/services/image.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-add-brand',
  templateUrl: './add-brand.component.html',
  styleUrls: ['./add-brand.component.css']
})
export class AddBrandComponent implements OnInit {
  brandInfo: BrandModel =
  {
    brandCode:'',
    brandName:'',
    image:'',
    isActive:true,
    brandImageBinaryData:'',
    mimeType:'',
    id:0,
    size:0,
    moduleId:Enums.ModuleNames.Brand
  };
  imageBaseData: string | ArrayBuffer = null;
  mimeType:string = ''
  ImageBinaryData:string | ArrayBuffer = null
  imageName:string
  features: Features[] = [];
  isValidImg:boolean = false;
  constructor(
    public service: BrandService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private activeModal : NgbActiveModal,
    private secureStorage : SecureStorage,
    private imageService:ImageService
  ) { }

  ngOnInit(): void {
    this.getFeatures();
  }
  async getFeatures(){
    this.features = this.secureStorage.getKeyData('feature');
  }
  onChange(value: boolean) {
    this.brandInfo.isActive = value;
  }
  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.brandInfo.mimeType = files[0].type;
    this.brandInfo.image = files[0].name;
    this.brandInfo.size = files[0].size;
    this.imageName = file.name;
    let imgerrormsg = this.translate.instant("lblImageFormatError");
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const isValidFormate=this.imageService.validateImageFormat(this.brandInfo.mimeType);
    if(isValidFormate)
    {
    if(this.brandInfo.size < 100000)
    {
      reader.onload = (_readerEvent) => {
        me.imageBaseData = reader.result;
        this.brandInfo.brandImageBinaryData = reader.result.toString().replace('data:' +  this.brandInfo.mimeType  + ';base64,', '');
        this.ImageBinaryData = me.imageBaseData;
      };
      this.isValidImg = true;
    }
    else
    {
      this.isValidImg = false;
      let errormsg = this.translate.instant("lblSizeExceedError");
      this.toaster.error(errormsg);
    }
  }
  else {
    this.isValidImg = false
    this.spinner.hide();
    this.toaster.error(imgerrormsg);
  }
    reader.onerror = function (_error) {
      // This is intentional
    };

  }
  AddBrand(brand:BrandModel){
    this.spinner.show();
    if (this.features && this.features.length > 0) {
      let feature = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive
      brand.IntegrationWithDMS = feature;
    }
    let addedRentalCarMessage = this.translate.instant("lblBrandAddedCar");
    let alreadyAddedRentalCarMessage = this.translate.instant("lblBrandAlreadyAdded");
    let errorMessage = this.translate.instant("lblErrorMessage");
    let errorWarning = this.translate.instant("lblErrorWarningForValue");
    let imgerrormsg = this.translate.instant("lblImageFormatError");
    const isValidFormat=this.imageService.validateImageFormat(this.brandInfo.mimeType);
    if(isValidFormat)
    {
      this.service.AddBrand(brand).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          this.activeModal.close({ success: true });
          this.toaster.success(addedRentalCarMessage);
        }
        else if (res.responseCode === Enums.ErrorCodes.RentalCarAlreadyAdded) {
          this.spinner.hide();
          this.toaster.warning(alreadyAddedRentalCarMessage);
        }
      }, error => {
        this.spinner.hide();
        if (error.status === Enums.ErrorCodes.NotFound) {
          this.toaster.warning(errorWarning);
        }
        else {
          this.toaster.error(errorMessage);
        }
      });
    }
    else {
      this.spinner.hide();
      this.toaster.error(imgerrormsg);
    }
    this.spinner.hide();
  }
  OnClose(){
    this.activeModal.close({ success: false });
  }
}
